<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="invoiceClass"
      label-position="right"
      label-width="130px"
      class="form"
    >
      <el-form-item label="类目名称" prop="title">
        <el-input
          v-model="invoiceClass.title"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入类目名称"
        />
      </el-form-item>

      <el-form-item label="税率">
        <v-input-percentage
          v-model="invoiceClass.tax_rate"
          label="税率"
          prop="tax_rate"
          placeholder="请输入税率"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.invoiceClassList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update } from '@/api/invoice-class';
import { toCent, toYuan } from "@/filters";

export default {
  name: RouteConfig.invoiceClassEdit.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    invoiceClass: {
      update_time: 0,
      title: '',
      tax_rate: 0,
    },
    rules: {
      title: [{ required: true, message: '请输入类目名称', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.invoiceClass };
        postData.tax_rate = toCent(postData.tax_rate);
        const { isError } = await update(this.id, postData);
        this.isSaving = false;
        if (!isError) RouteConfig.invoiceClassList.back();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { invoiceClass } = this;
      const invoiceClassBackup = {};
      Object.keys(data).forEach(key => {
        if (key in invoiceClass) invoiceClassBackup[key] = data[key];
      });
      invoiceClassBackup.tax_rate = toYuan(invoiceClassBackup.tax_rate);
      Object.assign(invoiceClass, invoiceClassBackup);
    },
  },
};
</script>
